module.exports = __webpack_public_path__ + "img/icon.d8790e77.png";